export default __webpack_public_path__ + "static/media/clients_s.54a20356.jpg";